module.exports = __webpack_public_path__ + "img/unicorn.11c3bc3.png";